import httpClient from './httpClient';

// Gestão de usuários do backoffice (BFF: backoffice/users). Só o perfil de administrador de usuários alcança.
export const listUsers = async () => (await httpClient.get('/backoffice/users')).data;

export const getUserHistory = async (userId) => (await httpClient.get(`/backoffice/users/${userId}/history`)).data;

export const createUser = async ({ userName, email, initialPassword, roles }) =>
    (await httpClient.post('/backoffice/users', { userName, email: email || null, initialPassword, roles })).data;

export const setUserRoles = async (userId, roles) => (await httpClient.put(`/backoffice/users/${userId}/roles`, { roles })).data;

export const setUserActive = async (userId, active) => (await httpClient.put(`/backoffice/users/${userId}/active`, { active })).data;

export const resetUserPassword = async (userId, newPassword) =>
    httpClient.post(`/backoffice/users/${userId}/reset-password`, { newPassword });

const ACTION_LABELS = {
    created: 'Usuário criado',
    roles_changed: 'Perfis alterados',
    deactivated: 'Desativado',
    activated: 'Reativado',
    password_reset: 'Senha redefinida por um administrador',
    password_changed: 'Trocou a própria senha'
};

export const userActionLabel = (action) => ACTION_LABELS[action] || action;
